/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import './css/OrderTicket.css';
import { parseFlightText } from '../../Utils/FlightUtils';
import { getDayWordByQuantity } from '../../Utils/DateUtil';
import {
  ARRIVAL_NEXT_DAY,
  ARRIVAL_IN,
  ARRIVAL_LOCAL_TIME,
} from '../../Utils/Constants/GlobalConstants';
import { ReactComponent as Plane } from '../../images/plane-r.svg';

function OrderTicket(props) {
  const { title, segments } = props;
  const tooltipId = `ot-tooltip-${title}`;

  // "+1" -> next day, "+2" -> in 2 days
  const getDayShiftText = (dayShift) => {
    const days = parseInt(dayShift, 10);

    if (!days || days === 1) {
      return ARRIVAL_NEXT_DAY;
    }

    return `${ARRIVAL_IN} ${days} ${getDayWordByQuantity(
      days,
    )} ${ARRIVAL_LOCAL_TIME}`;
  };

  const renderPoint = (point, isArrival) => (
    <div className={`ot_point ${isArrival ? 'ot_point_arrival' : ''}`}>
      <div className="ot_time">
        {point.time}
        {point.dayShift && (
          <span
            className="ot_day_shift"
            data-tooltip-id={tooltipId}
            data-tooltip-content={getDayShiftText(point.dayShift)}
          >
            {point.dayShift}
          </span>
        )}
      </div>
      <div className="dbb_text_14">{point.port}</div>
      <div className="gr_text_13">{point.date}</div>
    </div>
  );

  const renderSegment = (text, index) => {
    const flight = parseFlightText(text);

    // unknown format: show the line as it was saved
    if (!flight) {
      return (
        <div key={`ot-segment-${index}`} className="ot_segment_text br_text_14">
          {text}
        </div>
      );
    }

    return (
      <div key={`ot-segment-${index}`} className="ot_segment">
        {renderPoint(flight.departure, false)}
        <div className="ot_route">
          <div className="ot_line">
            <span className="ot_dot" />
            <Plane className="ot_plane" />
            <span className="ot_dot" />
          </div>
          <div className="gr_text_12 ot_flight">
            {[flight.number, flight.company].filter((item) => item).join(' · ')}
          </div>
        </div>
        {renderPoint(flight.arrival, true)}
      </div>
    );
  };

  return (
    <div className="ot_ticket">
      <div className="ot_head">
        <span className="ot_head_icon">
          <Plane />
        </span>
        <span className="bm_text_16">{title}</span>
      </div>
      <div className="ot_body">{segments.map(renderSegment)}</div>
      {/* outside the time block not to inherit its bold font;
      fixed: the modal body clips overflow */}
      <Tooltip id={tooltipId} className="ot_tooltip" positionStrategy="fixed" />
    </div>
  );
}

OrderTicket.propTypes = {
  title: PropTypes.string.isRequired,
  segments: PropTypes.instanceOf(Array).isRequired,
};

export default OrderTicket;
